import React from 'react';
import { Link } from 'gatsby';

export const DropdownItem = ({ to, onClick, children }) => (
  <Link 
    to={to} 
    onClick={onClick}
    className="block px-4 py-2 text-gray-300 hover:text-white hover:bg-slate-700 transition-colors"
  >
    {children}
  </Link>
);